(function () {
  function initBuybox(root) {
    var variantsScript = root.querySelector('[data-fp-buybox-variants]');
    var variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      variants = [];
    }

    var colorButtons = Array.prototype.slice.call(root.querySelectorAll('[data-fp-buybox-color]'));
    var sizeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-fp-buybox-size-btn]'));
    var tierColorSelects = Array.prototype.slice.call(root.querySelectorAll('[data-fp-buybox-tier-color]'));
    var tierSizeSelects = Array.prototype.slice.call(root.querySelectorAll('[data-fp-buybox-tier-size]'));
    var tierEls = Array.prototype.slice.call(root.querySelectorAll('[data-fp-buybox-tier]'));
    var variantInput = root.querySelector('[data-fp-buybox-variant-input]');
    var quantityInput = root.querySelector('[data-fp-buybox-quantity-input]');
    var submitButton = root.querySelector('[data-fp-buybox-submit]');
    var submitLabel = root.querySelector('[data-fp-buybox-submit-label]');
    var form = root.querySelector('[data-fp-buybox-form]');
    var viewerCountEl = root.querySelector('[data-fp-buybox-viewer-count]');

    var selectedColor = colorButtons.length ? colorButtons[0].dataset.value : null;
    var selectedSize = sizeButtons.length ? sizeButtons[0].dataset.value : null;
    var selectedQuantity = 1;

    tierEls.forEach(function (tier) {
      if (tier.classList.contains('is-selected')) {
        selectedQuantity = parseInt(tier.dataset.quantity, 10);
      }
    });

    function findVariant(colorValue, sizeValue) {
      var match = variants.filter(function (v) {
        var colorOk = !colorValue || v.optionValue === colorValue;
        var sizeOk = !sizeValue || v.sizeValue === sizeValue;
        return colorOk && sizeOk;
      });
      return match[0] || variants[0];
    }

    function refresh() {
      var variant = findVariant(selectedColor, selectedSize);
      if (variant && variantInput) variantInput.value = variant.id;
      if (quantityInput) quantityInput.value = selectedQuantity;

      var unavailable = variant && !variant.available;
      if (submitButton) submitButton.disabled = !!unavailable;

      colorButtons.forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.dataset.value === selectedColor);
        var v = findVariant(btn.dataset.value, selectedSize);
        btn.disabled = !!(v && !v.available);
      });

      sizeButtons.forEach(function (btn) {
        btn.classList.toggle('is-selected', btn.dataset.value === selectedSize);
        var v = findVariant(selectedColor, btn.dataset.value);
        btn.disabled = !!(v && !v.available);
      });

      tierColorSelects.forEach(function (select) {
        if (selectedColor && select.value !== selectedColor) select.value = selectedColor;
      });
      tierSizeSelects.forEach(function (select) {
        if (selectedSize && select.value !== selectedSize) select.value = selectedSize;
      });

      tierEls.forEach(function (tier) {
        tier.classList.toggle('is-selected', parseInt(tier.dataset.quantity, 10) === selectedQuantity);
      });
    }

    colorButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        selectedColor = btn.dataset.value;
        refresh();
      });
    });

    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        selectedSize = btn.dataset.value;
        refresh();
      });
    });

    tierEls.forEach(function (tier) {
      tier.addEventListener('click', function () {
        selectedQuantity = parseInt(tier.dataset.quantity, 10);
        refresh();
      });
    });

    tierColorSelects.concat(tierSizeSelects).forEach(function (select) {
      select.addEventListener('click', function (event) {
        event.stopPropagation();
      });
      select.addEventListener('change', function () {
        if (select.hasAttribute('data-fp-buybox-tier-color')) {
          selectedColor = select.value;
        } else {
          selectedSize = select.value;
        }
        var tier = select.closest('[data-fp-buybox-tier]');
        if (tier) selectedQuantity = parseInt(tier.dataset.quantity, 10);
        refresh();
      });
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (submitButton) submitButton.disabled = true;

        var formData = new FormData(form);
        fetch(window.Shopify && window.routes ? window.routes.cart_add_url : '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        })
          .then(function (response) {
            return response.json();
          })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function () {
            if (submitButton) submitButton.disabled = false;
          });
      });
    }

    if (viewerCountEl) {
      var seed = 4 + Math.floor(Math.random() * 12);
      viewerCountEl.textContent = seed;
      setInterval(function () {
        var delta = Math.random() > 0.5 ? 1 : -1;
        seed = Math.max(3, Math.min(19, seed + delta));
        viewerCountEl.textContent = seed;
      }, 6000);
    }

    refresh();
  }

  document.querySelectorAll('[data-fp-buybox]').forEach(initBuybox);
})();
